
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dhbEh", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $7Ndnw = parcelRequire("7Ndnw");


var $7QUD1 = parcelRequire("7QUD1");


var $hIaUw = parcelRequire("hIaUw");


var $8a9Dm = parcelRequire("8a9Dm");


var $dizL5 = parcelRequire("dizL5");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $6UqI3 = parcelRequire("6UqI3");


var $6uUjl = parcelRequire("6uUjl");


var $3IBnw = parcelRequire("3IBnw");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3jwuS = parcelRequire("3jwuS");


var $c54hr = parcelRequire("c54hr");

















var $9hlns = parcelRequire("9hlns");


var $9fBoq = parcelRequire("9fBoq");


var $al4VD = parcelRequire("al4VD");

const $ced39bfea5ef5993$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isLoading: isLoading, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.isLoading ? "_syaz1rpy" : "_syazn7od",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLoading: isLoading, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.isLoading ? "_syaz1rpy" : "_syazn7od",
            __cmplp.className
        ])
    });
});
const $ced39bfea5ef5993$var$CenterSpinner = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18u0x0bf _19pkx0bf _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18u0x0bf _19pkx0bf _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $ced39bfea5ef5993$export$9f275aff884e1431 = (0, $3u0dr.isReactCompilerActiveV1)() ? function ForgeContentToolsItem(t0) {
    const $ = (0, $frIzR.c)(16);
    const { extension: extension, onClick: onClick, isLoading: isLoading } = t0;
    let t1;
    if ($[0] !== extension || $[1] !== onClick) {
        t1 = (e)=>{
            e.stopPropagation();
            onClick(extension);
        };
        $[0] = extension;
        $[1] = onClick;
        $[2] = t1;
    } else t1 = $[2];
    const onClickCB = t1;
    const t2 = extension.id;
    let t3;
    if ($[3] !== extension) {
        t3 = (0, $9fBoq.extensionTitle)(extension);
        $[3] = extension;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== isLoading) {
        t4 = isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small"
        }));
        $[5] = isLoading;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== isLoading || $[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, t3, t4);
        $[7] = isLoading;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== extension.id || $[12] !== isLoading || $[13] !== onClickCB || $[14] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $al4VD.ContentToolsItem), {
            id: t2,
            isDisabled: isLoading,
            label: t5,
            onClick: onClickCB
        });
        $[11] = extension.id;
        $[12] = isLoading;
        $[13] = onClickCB;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
} : function ForgeContentToolsItem({ extension: extension, onClick: onClick, isLoading: isLoading }) {
    const onClickCB = (0, $42omo.useCallback)((e)=>{
        e.stopPropagation();
        onClick(extension);
    }, [
        extension,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $al4VD.ContentToolsItem), {
        id: extension.id,
        isDisabled: isLoading,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, (0, $9fBoq.extensionTitle)(extension), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small"
        }))),
        onClick: onClickCB
    });
};
$ced39bfea5ef5993$export$9f275aff884e1431.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired
};



var $9MrOn = parcelRequire("9MrOn");

const $0c33e41081c1500e$var$EXPERIENCE_NAME = (0, $irVI7.VIEW_PAGE_CONTENT_TOOLS_FORGE_EXPERIENCE);
function $0c33e41081c1500e$export$7cf22b806dbb23cb({ contentId: contentId, spaceKey: spaceKey, children: children, onLoadComplete: onLoadComplete, isDropdownMenuOpen: isDropdownMenuOpen, lazyLoaderPlaceholderComponent: lazyLoaderPlaceholderComponent = null }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext)); // Forge menu items are behaving a little different than other menu items. They show a loading spinner if one of them
    // is clicked. There are a few different cases that needs to be handled while a forge extension is being loaded:
    // 1. Show a loading spinner while an extension id being loaded.
    //    - Stop showing the loading spinner once the extension is loaded.
    //    - Close the dropdown menu once the extension is loaded.
    // 2. If dropdown menu is closed while an extension is being loaded then stop loading the extension.
    // If there's a selected extension then `loadExtension` state changes like this:
    // +----------+----------------------+------------------+
    // |isLoading |   isDropdownMenuOpen |    loadExtension |
    // +----------------------------------------------------+
    // |          |                      |                  |
    // | false    |   false              |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | false    |   true               |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | true     |   false              |    false         |  --> stop loading the extension
    // |          |                      |                  |
    // | true     |   true               |    true          |  --> keep loading the extension
    // +----------+----------------------+------------------+
    const [extension, showExtension] = (0, $42omo.useState)(null);
    const [isLoading, setLoading] = (0, $42omo.useState)(false);
    const loadExtension = extension && !(isLoading && !isDropdownMenuOpen);
    (0, $42omo.useEffect)(()=>{
        if (!loadExtension) {
            experienceTracker.abort({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
                reason: 'Canceled by user'
            });
            setLoading(false);
            showExtension(null);
        }
    }, [
        loadExtension,
        experienceTracker
    ]);
    const onLoadCompleteCB = (0, $42omo.useCallback)(()=>{
        onLoadComplete();
        setLoading(false);
    }, [
        onLoadComplete,
        setLoading
    ]);
    const onCloseCB = (0, $42omo.useCallback)(()=>{
        showExtension(null);
    }, [
        showExtension
    ]);
    const onForgeExtensionClick = (0, $42omo.useCallback)((ext)=>{
        experienceTracker.start({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
            id: ext.id,
            timeout: 10000
        });
        showExtension(ext);
        setLoading(true);
    }, [
        showExtension,
        setLoading,
        experienceTracker
    ]);
    // shows up when preloaded in SSR. Shows up again when SPA takes over bf all queries are loaded.
    const LazyLoader = (0, $42omo.useMemo)(()=>(0, $dizL5.lazyForgeUIExtensionsWithLoader)(()=>lazyLoaderPlaceholderComponent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9MrOn.ContentToolsButton // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ), {
                isDisabled: !(window.__SSR_RENDERED__ || undefined)
            })), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, loadExtension && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$ForgeUIExtensionLoader, {
        extension: extension,
        contentId: contentId,
        spaceKey: spaceKey,
        onLoadComplete: onLoadCompleteCB,
        onClose: onCloseCB
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LazyLoader, {
        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
        render: (extensions, loading, error)=>{
            if (loading) return children([]);
            if (error) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).ECOSYSTEM
                });
                return children([]);
            }
            const result = extensions.map((ext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ced39bfea5ef5993$export$9f275aff884e1431), {
                    key: ext.id,
                    extension: ext,
                    onClick: onForgeExtensionClick,
                    isLoading: extension === ext
                }));
            return children(result);
        }
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c33e41081c1500e$var$InvisibleDiv = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0cglyw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
}); /**
     * LazyForgeUIExtension has its own loading spinner, however, we don't want to show it anywhere. We want to show a
     * loading spinner inside the menu item while loading the extension, and then close the menu once the loading is complete.
     * To accomplish that, we're rendering LazyForgeUIExtension inside an invisible div.
     * @param forgeExtension To be loaded.
     * @param contentId Passed down to ForgeUIExtension both contentId and spaceKey becomes available in the forge app with
     * `useProductContext` hook. For reference https://developer.atlassian.com/platform/forge/ui-hooks-reference/.
     * @param spaceKey Passed down to ForgeUIExtension.
     * @param onLoadComplete Triggered when the forge extension is loaded.
     * @param onClose Triggered when the rendered ModalDialog is closed. (Currently ContentAction forge component can only contain a ModalDialog)
     * @returns LazyForgeUIExtension inside an InvisibleDiv.
     * @constructor
     */ 
const $0c33e41081c1500e$var$ForgeUIExtensionLoader = (0, $3u0dr.isReactCompilerActiveV1)() ? function ForgeUIExtensionLoader(t0) {
    const $ = (0, $frIzR.c)(33);
    const { extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [t1] = (0, $ep3mz.usePageState)();
    const { routeName: routeName } = t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsCloseMenuDisabled: setIsCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuActions)();
    let t2;
    let t3;
    if ($[0] !== setIsCloseMenuDisabled) {
        t2 = ()=>{
            setIsCloseMenuDisabled(true);
            return ()=>{
                setIsCloseMenuDisabled(false);
            };
        };
        t3 = [
            setIsCloseMenuDisabled
        ];
        $[0] = setIsCloseMenuDisabled;
        $[1] = t2;
        $[2] = t3;
    } else {
        t2 = $[1];
        t3 = $[2];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[3] !== activationId || $[4] !== contentId || $[5] !== createAnalyticsEvent || $[6] !== experienceTracker || $[7] !== extension || $[8] !== onLoadComplete || $[9] !== routeName || $[10] !== spaceAlias || $[11] !== spaceId) {
        t4 = ()=>{
            experienceTracker.succeed({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME
            });
            onLoadComplete();
            const appId = (0, $8a9Dm.getAppId)(extension);
            const analyticEvent = createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "invoked",
                    actionSubject: "forgeExtension",
                    actionSubjectId: appId,
                    containerType: "space",
                    containerId: spaceId,
                    objectType: (0, $hIaUw.getContentType)(routeName),
                    objectId: contentId,
                    source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    attributes: {
                        activationId: activationId,
                        appId: appId,
                        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                        moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                        spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                        spaceId: spaceId
                    }
                }
            });
            analyticEvent.fire();
        };
        $[3] = activationId;
        $[4] = contentId;
        $[5] = createAnalyticsEvent;
        $[6] = experienceTracker;
        $[7] = extension;
        $[8] = onLoadComplete;
        $[9] = routeName;
        $[10] = spaceAlias;
        $[11] = spaceId;
        $[12] = t4;
    } else t4 = $[12];
    const onInitialRender = t4;
    if (!spaceKey) return null;
    const t5 = extension.id;
    const t6 = isLivePage ? "live" : null;
    let t7;
    if ($[13] !== routeName) {
        t7 = (0, $hIaUw.getContentType)(routeName);
        $[13] = routeName;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== contentId || $[16] !== t6 || $[17] !== t7) {
        t8 = {
            id: contentId,
            subtype: t6,
            type: t7
        };
        $[15] = contentId;
        $[16] = t6;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    const t9 = spaceKey || spaceAlias;
    let t10;
    if ($[19] !== spaceId || $[20] !== t9) {
        t10 = {
            key: t9,
            id: spaceId
        };
        $[19] = spaceId;
        $[20] = t9;
        $[21] = t10;
    } else t10 = $[21];
    let t11;
    if ($[22] !== t10 || $[23] !== t8) {
        t11 = {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            content: t8,
            space: t10
        };
        $[22] = t10;
        $[23] = t8;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== onClose || $[26] !== setIsCloseMenuDisabled) {
        t12 = ()=>{
            setIsCloseMenuDisabled(false);
            onClose();
        };
        $[25] = onClose;
        $[26] = setIsCloseMenuDisabled;
        $[27] = t12;
    } else t12 = $[27];
    let t13;
    if ($[28] !== extension || $[29] !== onInitialRender || $[30] !== t11 || $[31] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.ContentActionForgeApp), {
            key: t5,
            app: extension,
            extensionData: t11,
            onInitialRender: onInitialRender,
            onTearDown: t12
        }));
        $[28] = extension;
        $[29] = onInitialRender;
        $[30] = t11;
        $[31] = t12;
        $[32] = t13;
    } else t13 = $[32];
    return t13;
} : function ForgeUIExtensionLoader({ extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [{ routeName: routeName }] = (0, $ep3mz.usePageState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsCloseMenuDisabled: setIsCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuActions)();
    (0, $42omo.useEffect)(()=>{
        // Ensures the MoreActions dialog remains opened while the Forge app is running
        // Without this, interactions with any portals from UI Kit components will close the menu which closes the Forge app
        setIsCloseMenuDisabled(true);
        return ()=>{
            setIsCloseMenuDisabled(false);
        };
    }, [
        setIsCloseMenuDisabled
    ]);
    const onInitialRender = (0, $42omo.useCallback)(()=>{
        experienceTracker.succeed({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME
        });
        onLoadComplete();
        const appId = (0, $8a9Dm.getAppId)(extension);
        const analyticEvent = createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'invoked',
                actionSubject: 'forgeExtension',
                actionSubjectId: appId,
                containerType: 'space',
                containerId: spaceId,
                objectType: (0, $hIaUw.getContentType)(routeName),
                objectId: contentId,
                source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                attributes: {
                    activationId: activationId,
                    appId: appId,
                    moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                    spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                    spaceId: spaceId
                }
            }
        });
        analyticEvent.fire();
    }, [
        onLoadComplete,
        experienceTracker,
        activationId,
        createAnalyticsEvent,
        contentId,
        spaceAlias,
        spaceId,
        extension,
        routeName
    ]);
    if (!spaceKey) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.ContentActionForgeApp // this key is required to enable user switch in between different forge apps during loading of an extension
    ), {
        key: extension.id,
        app: extension,
        extensionData: {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            // This ts ignore can be removed once the ff is cleaned up.
            // @ts-ignore FIXME `type` is declared by `extensionData` to be required for `content`
            content: {
                id: contentId,
                subtype: isLivePage ? 'live' : null,
                type: (0, $hIaUw.getContentType)(routeName)
            },
            space: {
                key: spaceKey || spaceAlias,
                id: spaceId
            }
        },
        onInitialRender: onInitialRender,
        onTearDown: ()=>{
            setIsCloseMenuDisabled(false);
            onClose();
        }
    }));
};
$0c33e41081c1500e$var$ForgeUIExtensionLoader.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    onLoadComplete: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
module.exports["ForgeContentTools"] = $0c33e41081c1500e$export$7cf22b806dbb23cb;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("eUueK"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("duuuL"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("4W6Dx"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("k50yZ"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("aftx0"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("5ihVx"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("HOADX"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("h8qCH"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("arvUv"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("2JVqG"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("35WIo"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("7w26I"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("eUueK", function(module, exports) {

let $adadc00c5cc598e5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $adadc00c5cc598e5$var$load("2YffH"),
    $adadc00c5cc598e5$var$load("8Kivm"),
    $adadc00c5cc598e5$var$load("7oopt"),
    $adadc00c5cc598e5$var$load("c0myL"),
    $adadc00c5cc598e5$var$load("iQ0Jm"),
    $adadc00c5cc598e5$var$load("coJiW"),
    $adadc00c5cc598e5$var$load("2IqcP"),
    $adadc00c5cc598e5$var$load("3Q2kO"),
    $adadc00c5cc598e5$var$load("h4Nf7"),
    $adadc00c5cc598e5$var$load("7f9Fz"),
    $adadc00c5cc598e5$var$load("8YSo7"),
    $adadc00c5cc598e5$var$load("lYvov"),
    $adadc00c5cc598e5$var$load("k8XPW"),
    $adadc00c5cc598e5$var$load("fWCRm"),
    $adadc00c5cc598e5$var$load("g9CVe"),
    $adadc00c5cc598e5$var$load("aeEUI"),
    $adadc00c5cc598e5$var$load("hRUX7"),
    $adadc00c5cc598e5$var$load("g4oYs"),
    $adadc00c5cc598e5$var$load("6wr18"),
    $adadc00c5cc598e5$var$load("kjZZD"),
    $adadc00c5cc598e5$var$load("3ySTn"),
    $adadc00c5cc598e5$var$load("c2rHL"),
    $adadc00c5cc598e5$var$load("awqCy"),
    $adadc00c5cc598e5$var$load("kHOMt"),
    $adadc00c5cc598e5$var$load("hhss7"),
    $adadc00c5cc598e5$var$load("6kZfp"),
    $adadc00c5cc598e5$var$load("2UbDA"),
    $adadc00c5cc598e5$var$load("nbjnv"),
    $adadc00c5cc598e5$var$load("Wowvf"),
    $adadc00c5cc598e5$var$load("ffEVr"),
    $adadc00c5cc598e5$var$load("jlSv2"),
    $adadc00c5cc598e5$var$load("1UUrt"),
    $adadc00c5cc598e5$var$load("jSdjl"),
    $adadc00c5cc598e5$var$load("l2EUC"),
    $adadc00c5cc598e5$var$load("kWZnd"),
    $adadc00c5cc598e5$var$load("92LGf"),
    $adadc00c5cc598e5$var$load("let0D"),
    $adadc00c5cc598e5$var$load("joFPh"),
    $adadc00c5cc598e5$var$load("b7jBL"),
    $adadc00c5cc598e5$var$load("kUbUu"),
    $adadc00c5cc598e5$var$load("2PePB"),
    $adadc00c5cc598e5$var$load("1W4KB"),
    $adadc00c5cc598e5$var$load("lnKog"),
    $adadc00c5cc598e5$var$load("9ftJe"),
    $adadc00c5cc598e5$var$load("h3ABO"),
    $adadc00c5cc598e5$var$load("kC80R"),
    $adadc00c5cc598e5$var$load("7EorR"),
    $adadc00c5cc598e5$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("duuuL", function(module, exports) {

let $9d25bb6715051254$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9d25bb6715051254$var$load("2YffH"),
    $9d25bb6715051254$var$load("8Kivm"),
    $9d25bb6715051254$var$load("7oopt"),
    $9d25bb6715051254$var$load("c0myL"),
    $9d25bb6715051254$var$load("iQ0Jm"),
    $9d25bb6715051254$var$load("coJiW"),
    $9d25bb6715051254$var$load("2IqcP"),
    $9d25bb6715051254$var$load("3Q2kO"),
    $9d25bb6715051254$var$load("h4Nf7"),
    $9d25bb6715051254$var$load("7f9Fz"),
    $9d25bb6715051254$var$load("8YSo7"),
    $9d25bb6715051254$var$load("lYvov"),
    $9d25bb6715051254$var$load("k8XPW"),
    $9d25bb6715051254$var$load("fWCRm"),
    $9d25bb6715051254$var$load("g9CVe"),
    $9d25bb6715051254$var$load("aeEUI"),
    $9d25bb6715051254$var$load("hRUX7"),
    $9d25bb6715051254$var$load("g4oYs"),
    $9d25bb6715051254$var$load("6wr18"),
    $9d25bb6715051254$var$load("kjZZD"),
    $9d25bb6715051254$var$load("3ySTn"),
    $9d25bb6715051254$var$load("c2rHL"),
    $9d25bb6715051254$var$load("awqCy"),
    $9d25bb6715051254$var$load("kHOMt"),
    $9d25bb6715051254$var$load("hhss7"),
    $9d25bb6715051254$var$load("6kZfp"),
    $9d25bb6715051254$var$load("2UbDA"),
    $9d25bb6715051254$var$load("nbjnv"),
    $9d25bb6715051254$var$load("Wowvf"),
    $9d25bb6715051254$var$load("ffEVr"),
    $9d25bb6715051254$var$load("jlSv2"),
    $9d25bb6715051254$var$load("1UUrt"),
    $9d25bb6715051254$var$load("jSdjl"),
    $9d25bb6715051254$var$load("l2EUC"),
    $9d25bb6715051254$var$load("kWZnd"),
    $9d25bb6715051254$var$load("92LGf"),
    $9d25bb6715051254$var$load("let0D"),
    $9d25bb6715051254$var$load("joFPh"),
    $9d25bb6715051254$var$load("b7jBL"),
    $9d25bb6715051254$var$load("kUbUu"),
    $9d25bb6715051254$var$load("2PePB"),
    $9d25bb6715051254$var$load("1W4KB"),
    $9d25bb6715051254$var$load("lnKog"),
    $9d25bb6715051254$var$load("9ftJe"),
    $9d25bb6715051254$var$load("h3ABO"),
    $9d25bb6715051254$var$load("kC80R"),
    $9d25bb6715051254$var$load("7EorR"),
    $9d25bb6715051254$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("4W6Dx", function(module, exports) {

let $3981ba1a84037f72$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3981ba1a84037f72$var$load("2YffH"),
    $3981ba1a84037f72$var$load("8Kivm"),
    $3981ba1a84037f72$var$load("7oopt"),
    $3981ba1a84037f72$var$load("c0myL"),
    $3981ba1a84037f72$var$load("iQ0Jm"),
    $3981ba1a84037f72$var$load("coJiW"),
    $3981ba1a84037f72$var$load("2IqcP"),
    $3981ba1a84037f72$var$load("3Q2kO"),
    $3981ba1a84037f72$var$load("h4Nf7"),
    $3981ba1a84037f72$var$load("7f9Fz"),
    $3981ba1a84037f72$var$load("8YSo7"),
    $3981ba1a84037f72$var$load("lYvov"),
    $3981ba1a84037f72$var$load("k8XPW"),
    $3981ba1a84037f72$var$load("fWCRm"),
    $3981ba1a84037f72$var$load("g9CVe"),
    $3981ba1a84037f72$var$load("aeEUI"),
    $3981ba1a84037f72$var$load("hRUX7"),
    $3981ba1a84037f72$var$load("g4oYs"),
    $3981ba1a84037f72$var$load("6wr18"),
    $3981ba1a84037f72$var$load("kjZZD"),
    $3981ba1a84037f72$var$load("3ySTn"),
    $3981ba1a84037f72$var$load("c2rHL"),
    $3981ba1a84037f72$var$load("awqCy"),
    $3981ba1a84037f72$var$load("kHOMt"),
    $3981ba1a84037f72$var$load("hhss7"),
    $3981ba1a84037f72$var$load("6kZfp"),
    $3981ba1a84037f72$var$load("2UbDA"),
    $3981ba1a84037f72$var$load("nbjnv"),
    $3981ba1a84037f72$var$load("Wowvf"),
    $3981ba1a84037f72$var$load("ffEVr"),
    $3981ba1a84037f72$var$load("jlSv2"),
    $3981ba1a84037f72$var$load("1UUrt"),
    $3981ba1a84037f72$var$load("jSdjl"),
    $3981ba1a84037f72$var$load("l2EUC"),
    $3981ba1a84037f72$var$load("kWZnd"),
    $3981ba1a84037f72$var$load("92LGf"),
    $3981ba1a84037f72$var$load("let0D"),
    $3981ba1a84037f72$var$load("joFPh"),
    $3981ba1a84037f72$var$load("b7jBL"),
    $3981ba1a84037f72$var$load("kUbUu"),
    $3981ba1a84037f72$var$load("2PePB"),
    $3981ba1a84037f72$var$load("1W4KB"),
    $3981ba1a84037f72$var$load("lnKog"),
    $3981ba1a84037f72$var$load("9ftJe"),
    $3981ba1a84037f72$var$load("h3ABO"),
    $3981ba1a84037f72$var$load("kC80R"),
    $3981ba1a84037f72$var$load("7EorR"),
    $3981ba1a84037f72$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("k50yZ", function(module, exports) {

let $e9e4b620588f258d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e9e4b620588f258d$var$load("k8XPW"),
    $e9e4b620588f258d$var$load("fWCRm"),
    $e9e4b620588f258d$var$load("2YffH"),
    $e9e4b620588f258d$var$load("2PePB"),
    $e9e4b620588f258d$var$load("7oopt"),
    $e9e4b620588f258d$var$load("c0myL"),
    $e9e4b620588f258d$var$load("2IqcP"),
    $e9e4b620588f258d$var$load("3Q2kO"),
    $e9e4b620588f258d$var$load("h4Nf7"),
    $e9e4b620588f258d$var$load("7f9Fz"),
    $e9e4b620588f258d$var$load("8YSo7"),
    $e9e4b620588f258d$var$load("lYvov"),
    $e9e4b620588f258d$var$load("g9CVe"),
    $e9e4b620588f258d$var$load("aeEUI"),
    $e9e4b620588f258d$var$load("hRUX7"),
    $e9e4b620588f258d$var$load("g4oYs"),
    $e9e4b620588f258d$var$load("6wr18"),
    $e9e4b620588f258d$var$load("kjZZD"),
    $e9e4b620588f258d$var$load("3ySTn"),
    $e9e4b620588f258d$var$load("c2rHL"),
    $e9e4b620588f258d$var$load("awqCy"),
    $e9e4b620588f258d$var$load("kHOMt"),
    $e9e4b620588f258d$var$load("hhss7"),
    $e9e4b620588f258d$var$load("6kZfp"),
    $e9e4b620588f258d$var$load("2UbDA"),
    $e9e4b620588f258d$var$load("nbjnv"),
    $e9e4b620588f258d$var$load("Wowvf"),
    $e9e4b620588f258d$var$load("ffEVr"),
    $e9e4b620588f258d$var$load("jlSv2"),
    $e9e4b620588f258d$var$load("1UUrt"),
    $e9e4b620588f258d$var$load("jSdjl"),
    $e9e4b620588f258d$var$load("l2EUC"),
    $e9e4b620588f258d$var$load("kWZnd"),
    $e9e4b620588f258d$var$load("92LGf"),
    $e9e4b620588f258d$var$load("let0D"),
    $e9e4b620588f258d$var$load("joFPh"),
    $e9e4b620588f258d$var$load("b7jBL"),
    $e9e4b620588f258d$var$load("1W4KB"),
    $e9e4b620588f258d$var$load("kUbUu"),
    $e9e4b620588f258d$var$load("9ftJe"),
    $e9e4b620588f258d$var$load("h3ABO"),
    $e9e4b620588f258d$var$load("kC80R"),
    $e9e4b620588f258d$var$load("7EorR"),
    $e9e4b620588f258d$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("aftx0", function(module, exports) {

let $77623668af190ac9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $77623668af190ac9$var$load("k8XPW"),
    $77623668af190ac9$var$load("fWCRm"),
    $77623668af190ac9$var$load("2YffH"),
    $77623668af190ac9$var$load("2PePB"),
    $77623668af190ac9$var$load("7oopt"),
    $77623668af190ac9$var$load("c0myL"),
    $77623668af190ac9$var$load("2IqcP"),
    $77623668af190ac9$var$load("3Q2kO"),
    $77623668af190ac9$var$load("h4Nf7"),
    $77623668af190ac9$var$load("7f9Fz"),
    $77623668af190ac9$var$load("8YSo7"),
    $77623668af190ac9$var$load("lYvov"),
    $77623668af190ac9$var$load("g9CVe"),
    $77623668af190ac9$var$load("aeEUI"),
    $77623668af190ac9$var$load("hRUX7"),
    $77623668af190ac9$var$load("g4oYs"),
    $77623668af190ac9$var$load("6wr18"),
    $77623668af190ac9$var$load("kjZZD"),
    $77623668af190ac9$var$load("3ySTn"),
    $77623668af190ac9$var$load("c2rHL"),
    $77623668af190ac9$var$load("awqCy"),
    $77623668af190ac9$var$load("kHOMt"),
    $77623668af190ac9$var$load("hhss7"),
    $77623668af190ac9$var$load("6kZfp"),
    $77623668af190ac9$var$load("2UbDA"),
    $77623668af190ac9$var$load("nbjnv"),
    $77623668af190ac9$var$load("Wowvf"),
    $77623668af190ac9$var$load("ffEVr"),
    $77623668af190ac9$var$load("jlSv2"),
    $77623668af190ac9$var$load("1UUrt"),
    $77623668af190ac9$var$load("jSdjl"),
    $77623668af190ac9$var$load("l2EUC"),
    $77623668af190ac9$var$load("kWZnd"),
    $77623668af190ac9$var$load("92LGf"),
    $77623668af190ac9$var$load("let0D"),
    $77623668af190ac9$var$load("joFPh"),
    $77623668af190ac9$var$load("b7jBL"),
    $77623668af190ac9$var$load("1W4KB"),
    $77623668af190ac9$var$load("kUbUu"),
    $77623668af190ac9$var$load("9ftJe"),
    $77623668af190ac9$var$load("h3ABO"),
    $77623668af190ac9$var$load("kC80R"),
    $77623668af190ac9$var$load("7EorR"),
    $77623668af190ac9$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("5ihVx", function(module, exports) {

let $3dac8a20766ae2d0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3dac8a20766ae2d0$var$load("k8XPW"),
    $3dac8a20766ae2d0$var$load("fWCRm"),
    $3dac8a20766ae2d0$var$load("2YffH"),
    $3dac8a20766ae2d0$var$load("2PePB"),
    $3dac8a20766ae2d0$var$load("7oopt"),
    $3dac8a20766ae2d0$var$load("c0myL"),
    $3dac8a20766ae2d0$var$load("2IqcP"),
    $3dac8a20766ae2d0$var$load("3Q2kO"),
    $3dac8a20766ae2d0$var$load("h4Nf7"),
    $3dac8a20766ae2d0$var$load("7f9Fz"),
    $3dac8a20766ae2d0$var$load("8YSo7"),
    $3dac8a20766ae2d0$var$load("lYvov"),
    $3dac8a20766ae2d0$var$load("g9CVe"),
    $3dac8a20766ae2d0$var$load("aeEUI"),
    $3dac8a20766ae2d0$var$load("hRUX7"),
    $3dac8a20766ae2d0$var$load("g4oYs"),
    $3dac8a20766ae2d0$var$load("6wr18"),
    $3dac8a20766ae2d0$var$load("kjZZD"),
    $3dac8a20766ae2d0$var$load("3ySTn"),
    $3dac8a20766ae2d0$var$load("c2rHL"),
    $3dac8a20766ae2d0$var$load("awqCy"),
    $3dac8a20766ae2d0$var$load("kHOMt"),
    $3dac8a20766ae2d0$var$load("hhss7"),
    $3dac8a20766ae2d0$var$load("6kZfp"),
    $3dac8a20766ae2d0$var$load("2UbDA"),
    $3dac8a20766ae2d0$var$load("nbjnv"),
    $3dac8a20766ae2d0$var$load("Wowvf"),
    $3dac8a20766ae2d0$var$load("ffEVr"),
    $3dac8a20766ae2d0$var$load("jlSv2"),
    $3dac8a20766ae2d0$var$load("1UUrt"),
    $3dac8a20766ae2d0$var$load("jSdjl"),
    $3dac8a20766ae2d0$var$load("l2EUC"),
    $3dac8a20766ae2d0$var$load("kWZnd"),
    $3dac8a20766ae2d0$var$load("92LGf"),
    $3dac8a20766ae2d0$var$load("let0D"),
    $3dac8a20766ae2d0$var$load("joFPh"),
    $3dac8a20766ae2d0$var$load("b7jBL"),
    $3dac8a20766ae2d0$var$load("1W4KB"),
    $3dac8a20766ae2d0$var$load("kUbUu"),
    $3dac8a20766ae2d0$var$load("9ftJe"),
    $3dac8a20766ae2d0$var$load("h3ABO"),
    $3dac8a20766ae2d0$var$load("kC80R"),
    $3dac8a20766ae2d0$var$load("7EorR"),
    $3dac8a20766ae2d0$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("HOADX", function(module, exports) {

let $083b42643d58e6b5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $083b42643d58e6b5$var$load("k8XPW"),
    $083b42643d58e6b5$var$load("fWCRm"),
    $083b42643d58e6b5$var$load("2YffH"),
    $083b42643d58e6b5$var$load("7oopt"),
    $083b42643d58e6b5$var$load("c0myL"),
    $083b42643d58e6b5$var$load("2IqcP"),
    $083b42643d58e6b5$var$load("3Q2kO"),
    $083b42643d58e6b5$var$load("h4Nf7"),
    $083b42643d58e6b5$var$load("7f9Fz"),
    $083b42643d58e6b5$var$load("8YSo7"),
    $083b42643d58e6b5$var$load("lYvov"),
    $083b42643d58e6b5$var$load("g9CVe"),
    $083b42643d58e6b5$var$load("aeEUI"),
    $083b42643d58e6b5$var$load("hRUX7"),
    $083b42643d58e6b5$var$load("g4oYs"),
    $083b42643d58e6b5$var$load("6wr18"),
    $083b42643d58e6b5$var$load("kjZZD"),
    $083b42643d58e6b5$var$load("3ySTn"),
    $083b42643d58e6b5$var$load("c2rHL"),
    $083b42643d58e6b5$var$load("awqCy"),
    $083b42643d58e6b5$var$load("kHOMt"),
    $083b42643d58e6b5$var$load("hhss7"),
    $083b42643d58e6b5$var$load("6kZfp"),
    $083b42643d58e6b5$var$load("2UbDA"),
    $083b42643d58e6b5$var$load("nbjnv"),
    $083b42643d58e6b5$var$load("Wowvf"),
    $083b42643d58e6b5$var$load("ffEVr"),
    $083b42643d58e6b5$var$load("jlSv2"),
    $083b42643d58e6b5$var$load("1UUrt"),
    $083b42643d58e6b5$var$load("jSdjl"),
    $083b42643d58e6b5$var$load("l2EUC"),
    $083b42643d58e6b5$var$load("kWZnd"),
    $083b42643d58e6b5$var$load("92LGf"),
    $083b42643d58e6b5$var$load("let0D"),
    $083b42643d58e6b5$var$load("joFPh"),
    $083b42643d58e6b5$var$load("b7jBL"),
    $083b42643d58e6b5$var$load("kUbUu"),
    $083b42643d58e6b5$var$load("2PePB"),
    $083b42643d58e6b5$var$load("1W4KB"),
    $083b42643d58e6b5$var$load("lnKog"),
    $083b42643d58e6b5$var$load("9ftJe"),
    $083b42643d58e6b5$var$load("h3ABO"),
    $083b42643d58e6b5$var$load("kC80R"),
    $083b42643d58e6b5$var$load("7EorR"),
    $083b42643d58e6b5$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("h8qCH", function(module, exports) {

let $c797d5d9e2dd4c44$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c797d5d9e2dd4c44$var$load("2YffH"),
    $c797d5d9e2dd4c44$var$load("7oopt"),
    $c797d5d9e2dd4c44$var$load("c0myL"),
    $c797d5d9e2dd4c44$var$load("coJiW"),
    $c797d5d9e2dd4c44$var$load("2IqcP"),
    $c797d5d9e2dd4c44$var$load("3Q2kO"),
    $c797d5d9e2dd4c44$var$load("h4Nf7"),
    $c797d5d9e2dd4c44$var$load("7f9Fz"),
    $c797d5d9e2dd4c44$var$load("8YSo7"),
    $c797d5d9e2dd4c44$var$load("lYvov"),
    $c797d5d9e2dd4c44$var$load("k8XPW"),
    $c797d5d9e2dd4c44$var$load("fWCRm"),
    $c797d5d9e2dd4c44$var$load("g9CVe"),
    $c797d5d9e2dd4c44$var$load("aeEUI"),
    $c797d5d9e2dd4c44$var$load("hRUX7"),
    $c797d5d9e2dd4c44$var$load("g4oYs"),
    $c797d5d9e2dd4c44$var$load("6wr18"),
    $c797d5d9e2dd4c44$var$load("kjZZD"),
    $c797d5d9e2dd4c44$var$load("3ySTn"),
    $c797d5d9e2dd4c44$var$load("c2rHL"),
    $c797d5d9e2dd4c44$var$load("dTsOE"),
    $c797d5d9e2dd4c44$var$load("awqCy"),
    $c797d5d9e2dd4c44$var$load("kHOMt"),
    $c797d5d9e2dd4c44$var$load("hhss7"),
    $c797d5d9e2dd4c44$var$load("6kZfp"),
    $c797d5d9e2dd4c44$var$load("2UbDA"),
    $c797d5d9e2dd4c44$var$load("nbjnv"),
    $c797d5d9e2dd4c44$var$load("Wowvf"),
    $c797d5d9e2dd4c44$var$load("ffEVr"),
    $c797d5d9e2dd4c44$var$load("jlSv2"),
    $c797d5d9e2dd4c44$var$load("1UUrt"),
    $c797d5d9e2dd4c44$var$load("jSdjl"),
    $c797d5d9e2dd4c44$var$load("l2EUC"),
    $c797d5d9e2dd4c44$var$load("kWZnd"),
    $c797d5d9e2dd4c44$var$load("92LGf"),
    $c797d5d9e2dd4c44$var$load("let0D"),
    $c797d5d9e2dd4c44$var$load("joFPh"),
    $c797d5d9e2dd4c44$var$load("b7jBL"),
    $c797d5d9e2dd4c44$var$load("kUbUu"),
    $c797d5d9e2dd4c44$var$load("2PePB"),
    $c797d5d9e2dd4c44$var$load("1W4KB"),
    $c797d5d9e2dd4c44$var$load("lnKog"),
    $c797d5d9e2dd4c44$var$load("9ftJe"),
    $c797d5d9e2dd4c44$var$load("h3ABO"),
    $c797d5d9e2dd4c44$var$load("kC80R"),
    $c797d5d9e2dd4c44$var$load("7EorR"),
    $c797d5d9e2dd4c44$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("arvUv", function(module, exports) {

let $79a52dc22d23cd69$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $79a52dc22d23cd69$var$load("2YffH"),
    $79a52dc22d23cd69$var$load("7oopt"),
    $79a52dc22d23cd69$var$load("c0myL"),
    $79a52dc22d23cd69$var$load("coJiW"),
    $79a52dc22d23cd69$var$load("2IqcP"),
    $79a52dc22d23cd69$var$load("3Q2kO"),
    $79a52dc22d23cd69$var$load("h4Nf7"),
    $79a52dc22d23cd69$var$load("7f9Fz"),
    $79a52dc22d23cd69$var$load("8YSo7"),
    $79a52dc22d23cd69$var$load("lYvov"),
    $79a52dc22d23cd69$var$load("k8XPW"),
    $79a52dc22d23cd69$var$load("fWCRm"),
    $79a52dc22d23cd69$var$load("g9CVe"),
    $79a52dc22d23cd69$var$load("aeEUI"),
    $79a52dc22d23cd69$var$load("hRUX7"),
    $79a52dc22d23cd69$var$load("g4oYs"),
    $79a52dc22d23cd69$var$load("6wr18"),
    $79a52dc22d23cd69$var$load("kjZZD"),
    $79a52dc22d23cd69$var$load("3ySTn"),
    $79a52dc22d23cd69$var$load("c2rHL"),
    $79a52dc22d23cd69$var$load("dTsOE"),
    $79a52dc22d23cd69$var$load("awqCy"),
    $79a52dc22d23cd69$var$load("kHOMt"),
    $79a52dc22d23cd69$var$load("hhss7"),
    $79a52dc22d23cd69$var$load("6kZfp"),
    $79a52dc22d23cd69$var$load("2UbDA"),
    $79a52dc22d23cd69$var$load("nbjnv"),
    $79a52dc22d23cd69$var$load("Wowvf"),
    $79a52dc22d23cd69$var$load("ffEVr"),
    $79a52dc22d23cd69$var$load("jlSv2"),
    $79a52dc22d23cd69$var$load("1UUrt"),
    $79a52dc22d23cd69$var$load("jSdjl"),
    $79a52dc22d23cd69$var$load("l2EUC"),
    $79a52dc22d23cd69$var$load("kWZnd"),
    $79a52dc22d23cd69$var$load("92LGf"),
    $79a52dc22d23cd69$var$load("let0D"),
    $79a52dc22d23cd69$var$load("joFPh"),
    $79a52dc22d23cd69$var$load("b7jBL"),
    $79a52dc22d23cd69$var$load("kUbUu"),
    $79a52dc22d23cd69$var$load("2PePB"),
    $79a52dc22d23cd69$var$load("1W4KB"),
    $79a52dc22d23cd69$var$load("lnKog"),
    $79a52dc22d23cd69$var$load("9ftJe"),
    $79a52dc22d23cd69$var$load("h3ABO"),
    $79a52dc22d23cd69$var$load("kC80R"),
    $79a52dc22d23cd69$var$load("7EorR"),
    $79a52dc22d23cd69$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("2JVqG", function(module, exports) {

let $1fec5507e8cbf8ff$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1fec5507e8cbf8ff$var$load("k8XPW"),
    $1fec5507e8cbf8ff$var$load("fWCRm"),
    $1fec5507e8cbf8ff$var$load("2YffH"),
    $1fec5507e8cbf8ff$var$load("2PePB"),
    $1fec5507e8cbf8ff$var$load("7oopt"),
    $1fec5507e8cbf8ff$var$load("c0myL"),
    $1fec5507e8cbf8ff$var$load("2IqcP"),
    $1fec5507e8cbf8ff$var$load("3Q2kO"),
    $1fec5507e8cbf8ff$var$load("h4Nf7"),
    $1fec5507e8cbf8ff$var$load("7f9Fz"),
    $1fec5507e8cbf8ff$var$load("8YSo7"),
    $1fec5507e8cbf8ff$var$load("lYvov"),
    $1fec5507e8cbf8ff$var$load("g9CVe"),
    $1fec5507e8cbf8ff$var$load("aeEUI"),
    $1fec5507e8cbf8ff$var$load("hRUX7"),
    $1fec5507e8cbf8ff$var$load("g4oYs"),
    $1fec5507e8cbf8ff$var$load("6wr18"),
    $1fec5507e8cbf8ff$var$load("kjZZD"),
    $1fec5507e8cbf8ff$var$load("3ySTn"),
    $1fec5507e8cbf8ff$var$load("c2rHL"),
    $1fec5507e8cbf8ff$var$load("awqCy"),
    $1fec5507e8cbf8ff$var$load("kHOMt"),
    $1fec5507e8cbf8ff$var$load("hhss7"),
    $1fec5507e8cbf8ff$var$load("6kZfp"),
    $1fec5507e8cbf8ff$var$load("2UbDA"),
    $1fec5507e8cbf8ff$var$load("nbjnv"),
    $1fec5507e8cbf8ff$var$load("Wowvf"),
    $1fec5507e8cbf8ff$var$load("ffEVr"),
    $1fec5507e8cbf8ff$var$load("jlSv2"),
    $1fec5507e8cbf8ff$var$load("1UUrt"),
    $1fec5507e8cbf8ff$var$load("jSdjl"),
    $1fec5507e8cbf8ff$var$load("l2EUC"),
    $1fec5507e8cbf8ff$var$load("kWZnd"),
    $1fec5507e8cbf8ff$var$load("92LGf"),
    $1fec5507e8cbf8ff$var$load("let0D"),
    $1fec5507e8cbf8ff$var$load("joFPh"),
    $1fec5507e8cbf8ff$var$load("b7jBL"),
    $1fec5507e8cbf8ff$var$load("1W4KB"),
    $1fec5507e8cbf8ff$var$load("kUbUu"),
    $1fec5507e8cbf8ff$var$load("9ftJe"),
    $1fec5507e8cbf8ff$var$load("h3ABO"),
    $1fec5507e8cbf8ff$var$load("kC80R"),
    $1fec5507e8cbf8ff$var$load("7EorR"),
    $1fec5507e8cbf8ff$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("35WIo", function(module, exports) {

let $240f6250d44783b2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $240f6250d44783b2$var$load("k8XPW"),
    $240f6250d44783b2$var$load("fWCRm"),
    $240f6250d44783b2$var$load("2YffH"),
    $240f6250d44783b2$var$load("7oopt"),
    $240f6250d44783b2$var$load("c0myL"),
    $240f6250d44783b2$var$load("2IqcP"),
    $240f6250d44783b2$var$load("3Q2kO"),
    $240f6250d44783b2$var$load("h4Nf7"),
    $240f6250d44783b2$var$load("7f9Fz"),
    $240f6250d44783b2$var$load("8YSo7"),
    $240f6250d44783b2$var$load("lYvov"),
    $240f6250d44783b2$var$load("g9CVe"),
    $240f6250d44783b2$var$load("aeEUI"),
    $240f6250d44783b2$var$load("hRUX7"),
    $240f6250d44783b2$var$load("g4oYs"),
    $240f6250d44783b2$var$load("6wr18"),
    $240f6250d44783b2$var$load("kjZZD"),
    $240f6250d44783b2$var$load("3ySTn"),
    $240f6250d44783b2$var$load("c2rHL"),
    $240f6250d44783b2$var$load("awqCy"),
    $240f6250d44783b2$var$load("kHOMt"),
    $240f6250d44783b2$var$load("hhss7"),
    $240f6250d44783b2$var$load("6kZfp"),
    $240f6250d44783b2$var$load("2UbDA"),
    $240f6250d44783b2$var$load("nbjnv"),
    $240f6250d44783b2$var$load("Wowvf"),
    $240f6250d44783b2$var$load("ffEVr"),
    $240f6250d44783b2$var$load("jlSv2"),
    $240f6250d44783b2$var$load("1UUrt"),
    $240f6250d44783b2$var$load("jSdjl"),
    $240f6250d44783b2$var$load("l2EUC"),
    $240f6250d44783b2$var$load("kWZnd"),
    $240f6250d44783b2$var$load("92LGf"),
    $240f6250d44783b2$var$load("let0D"),
    $240f6250d44783b2$var$load("joFPh"),
    $240f6250d44783b2$var$load("b7jBL"),
    $240f6250d44783b2$var$load("kUbUu"),
    $240f6250d44783b2$var$load("2PePB"),
    $240f6250d44783b2$var$load("1W4KB"),
    $240f6250d44783b2$var$load("lnKog"),
    $240f6250d44783b2$var$load("9ftJe"),
    $240f6250d44783b2$var$load("h3ABO"),
    $240f6250d44783b2$var$load("kC80R"),
    $240f6250d44783b2$var$load("7EorR"),
    $240f6250d44783b2$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("7w26I", function(module, exports) {

let $578d280e0c6430b5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $578d280e0c6430b5$var$load("k8XPW"),
    $578d280e0c6430b5$var$load("fWCRm"),
    $578d280e0c6430b5$var$load("2YffH"),
    $578d280e0c6430b5$var$load("7oopt"),
    $578d280e0c6430b5$var$load("c0myL"),
    $578d280e0c6430b5$var$load("2IqcP"),
    $578d280e0c6430b5$var$load("3Q2kO"),
    $578d280e0c6430b5$var$load("h4Nf7"),
    $578d280e0c6430b5$var$load("7f9Fz"),
    $578d280e0c6430b5$var$load("8YSo7"),
    $578d280e0c6430b5$var$load("lYvov"),
    $578d280e0c6430b5$var$load("g9CVe"),
    $578d280e0c6430b5$var$load("aeEUI"),
    $578d280e0c6430b5$var$load("hRUX7"),
    $578d280e0c6430b5$var$load("g4oYs"),
    $578d280e0c6430b5$var$load("6wr18"),
    $578d280e0c6430b5$var$load("kjZZD"),
    $578d280e0c6430b5$var$load("3ySTn"),
    $578d280e0c6430b5$var$load("c2rHL"),
    $578d280e0c6430b5$var$load("awqCy"),
    $578d280e0c6430b5$var$load("kHOMt"),
    $578d280e0c6430b5$var$load("hhss7"),
    $578d280e0c6430b5$var$load("6kZfp"),
    $578d280e0c6430b5$var$load("2UbDA"),
    $578d280e0c6430b5$var$load("nbjnv"),
    $578d280e0c6430b5$var$load("Wowvf"),
    $578d280e0c6430b5$var$load("ffEVr"),
    $578d280e0c6430b5$var$load("jlSv2"),
    $578d280e0c6430b5$var$load("1UUrt"),
    $578d280e0c6430b5$var$load("jSdjl"),
    $578d280e0c6430b5$var$load("l2EUC"),
    $578d280e0c6430b5$var$load("kWZnd"),
    $578d280e0c6430b5$var$load("92LGf"),
    $578d280e0c6430b5$var$load("let0D"),
    $578d280e0c6430b5$var$load("joFPh"),
    $578d280e0c6430b5$var$load("b7jBL"),
    $578d280e0c6430b5$var$load("kUbUu"),
    $578d280e0c6430b5$var$load("2PePB"),
    $578d280e0c6430b5$var$load("1W4KB"),
    $578d280e0c6430b5$var$load("lnKog"),
    $578d280e0c6430b5$var$load("9ftJe"),
    $578d280e0c6430b5$var$load("h3ABO"),
    $578d280e0c6430b5$var$load("kC80R"),
    $578d280e0c6430b5$var$load("7EorR"),
    $578d280e0c6430b5$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("bSdpv"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("bSdpv", function(module, exports) {

let $8a4f23dbcd20a889$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8a4f23dbcd20a889$var$load("2PePB"),
    $8a4f23dbcd20a889$var$load("1W4KB"),
    $8a4f23dbcd20a889$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});

parcelRegister("6UqI3", function(module, exports) {
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};
module.exports["getSpaceType"] = $a3c7cd489159fe33$export$28eddf802cd184f7;

});

parcelRegister("c54hr", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $367766f6f044c46b$var$initialState = {
    isMenuOpen: false,
    isCloseMenuDisabled: false
};
const $367766f6f044c46b$var$actions = {
    setIsMenuOpen: (isMenuOpen)=>({ setState: setState })=>{
            setState({
                isMenuOpen: isMenuOpen
            });
        },
    setIsCloseMenuDisabled: (isCloseMenuDisabled)=>({ setState: setState })=>{
            setState({
                isCloseMenuDisabled: isCloseMenuDisabled
            });
        }
};
const $367766f6f044c46b$var$Store = (0, $1P1Tu.createStore)({
    initialState: $367766f6f044c46b$var$initialState,
    actions: $367766f6f044c46b$var$actions,
    name: 'more-actions-menu-store'
});
const $367766f6f044c46b$export$14d00db016c2b3ef = (0, $9zUhf.createStateHook)($367766f6f044c46b$var$Store);
const $367766f6f044c46b$export$1f1f8c486fa8a1cb = (0, $9zUhf.createActionsHook)($367766f6f044c46b$var$Store);
module.exports["useMoreActionsMenuState"] = $367766f6f044c46b$export$14d00db016c2b3ef;
module.exports["useMoreActionsMenuActions"] = $367766f6f044c46b$export$1f1f8c486fa8a1cb;

});

parcelRegister("9fBoq", function(module, exports) {
parcelRequire("1c598");
var $1Aku8 = parcelRequire("1Aku8");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $1Aku8.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $1Aku8.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("1c598", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);
parcelRequire("i3Ypo");
var $2JC3k = parcelRequire("2JC3k");
var $1Aku8 = parcelRequire("1Aku8");
var $9dbGT = parcelRequire("9dbGT");

parcelRequire("jUCNB");
var $gUjm2 = parcelRequire("gUjm2");
var $kg3OT = parcelRequire("kg3OT");
var $fsQJy = parcelRequire("fsQJy");


});

parcelRegister("i3Ypo", function(module, exports) {
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);

var $9dbGT = parcelRequire("9dbGT");


var $1Aku8 = parcelRequire("1Aku8");


var $6sM2K = parcelRequire("6sM2K");


var $2JC3k = parcelRequire("2JC3k");


});

parcelRegister("9dbGT", function(module, exports) {
const $1ec3e8240f57817b$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $1ec3e8240f57817b$export$3ee8c58bb87b9685 = [
    ...$1ec3e8240f57817b$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];
module.exports["MarkupRecursiveList"] = $1ec3e8240f57817b$export$3b98ab6402702476;
module.exports["MarkupList"] = $1ec3e8240f57817b$export$3ee8c58bb87b9685;

});

parcelRegister("1Aku8", function(module, exports) {
var $d128cc36ec70c56c$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $d128cc36ec70c56c$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $d128cc36ec70c56c$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $d128cc36ec70c56c$export$beaef1891b3e7ca3;

});

parcelRegister("6sM2K", function(module, exports) {
const $0e3337cb4407ef3b$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("2JC3k", function(module, exports) {
var $d977f97374f9d2c9$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $d977f97374f9d2c9$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    MACRO: 'xen:macro',
    TEST_MODULE: 'test:module'
};
const $d977f97374f9d2c9$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
module.exports["ExtensionEnvironment"] = $d977f97374f9d2c9$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $d977f97374f9d2c9$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $d977f97374f9d2c9$export$f06ffa3aa6bfec95;

});

parcelRegister("jUCNB", function(module, exports) {

var $fsQJy = parcelRequire("fsQJy");


var $kg3OT = parcelRequire("kg3OT");


var $gUjm2 = parcelRequire("gUjm2");


});

parcelRegister("fsQJy", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $8d78496ee677e86d$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $8d78496ee677e86d$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $8d78496ee677e86d$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $8d78496ee677e86d$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $8d78496ee677e86d$export$20b9f6acb0888554(effect) {
    return $8d78496ee677e86d$export$7e816460364ed464(effect) || $8d78496ee677e86d$export$eb5bd7f371e458af(effect) || $8d78496ee677e86d$export$f632ad3064955f31(effect);
}

});

parcelRegister("kg3OT", function(module, exports) {
const $bc3454970f51a505$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $bc3454970f51a505$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $bc3454970f51a505$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $bc3454970f51a505$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $bc3454970f51a505$export$caa8cab0db5b0a61(effect) {
    return $bc3454970f51a505$export$65d7078e01574f24(effect) || $bc3454970f51a505$export$709a27a9f80556b8(effect) || $bc3454970f51a505$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("gUjm2", function(module, exports) {
// From forge.ts
const $ce9f8921033c0d6d$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $ce9f8921033c0d6d$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $ce9f8921033c0d6d$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $ce9f8921033c0d6d$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $ce9f8921033c0d6d$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $ce9f8921033c0d6d$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $ce9f8921033c0d6d$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $ce9f8921033c0d6d$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $ce9f8921033c0d6d$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $ce9f8921033c0d6d$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $ce9f8921033c0d6d$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("9MrOn", function(module, exports) {
/* ContentToolsButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $9VJDA = parcelRequire("9VJDA");


var $1qfLF = parcelRequire("1qfLF");


var $52EPl = parcelRequire("52EPl");

const $43c0d8bb08806c39$var$NOOP = ()=>{};
const $43c0d8bb08806c39$var$i18n = (0, $cgtv4.defineMessages)({
    triggerLabel: {
        id: "content-tools.more.icon.label",
        defaultMessage: "More actions"
    }
});
const $43c0d8bb08806c39$var$dropdownMenuCollaboratorStyle = null;
const $43c0d8bb08806c39$var$dropdownMenuNonCollaboratorStyle = null;
const $43c0d8bb08806c39$var$ContentToolsButtonComponent = ({ isDisabled: isDisabled, isOpen: isOpen = false, onOpenChange: onOpenChange = $43c0d8bb08806c39$var$NOOP, onPositioned: onPositioned = $43c0d8bb08806c39$var$NOOP, children: children, isExternalCollaborator: isExternalCollaborator = false })=>{
    'use no memo';
    const intl = (0, $8C5kA.default)();
    const [drodownMenuMaxHeight, setDropdownMenuMaxHeight] = (0, $42omo.useState)('auto');
    const dropdownMenuContainerRef = (0, $42omo.useRef)(null);
    const handleOnOpenChange = (obj)=>{
        onOpenChange(obj);
        if (obj.isOpen) {
            const distanceFromTop = dropdownMenuContainerRef.current?.getBoundingClientRect().bottom ?? 0;
            const availableHeight = window.innerHeight - distanceFromTop - 16;
            setDropdownMenuMaxHeight(`${availableHeight}px`);
        }
    };
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-id": "content-tools-dropdown-menu-container",
        "data-test-id": "content-tools-dropdown-menu-container",
        "data-testid": "content-tools-dropdown-menu-container",
        ref: dropdownMenuContainerRef,
        className: (0, $gMc0m.default)([
            "_18u019bv _1ul91tcg",
            isExternalCollaborator && "_18u0idpf _1ul91tcg"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $52EPl.default), {
        testId: "content-tools-dropdown-menu",
        appearance: "tall",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
                ...props,
                "data-id": "page-more-action-button",
                "data-test-id": "page-more-action-button",
                id: "tools-menu-trigger",
                label: intl.formatMessage($43c0d8bb08806c39$var$i18n.triggerLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                ref: triggerRef,
                appearance: "subtle",
                isDisabled: isDisabled
            }),
        placement: "bottom-end",
        isOpen: isOpen,
        onOpenChange: handleOnOpenChange,
        shouldFlip: false,
        onPositioned: onPositioned,
        shouldRenderToParent: true
    }, /*#__PURE__*/ $42omo.createElement("div", {
        style: {
            maxHeight: drodownMenuMaxHeight
        }
    }, children || null)));
};
$43c0d8bb08806c39$var$ContentToolsButtonComponent.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).node,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isExternalCollaborator: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    onPositioned: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
};
const $43c0d8bb08806c39$export$f221d384e5b0f4c3 = /*#__PURE__*/ (0, $42omo.memo)($43c0d8bb08806c39$var$ContentToolsButtonComponent);
module.exports["ContentToolsButton"] = $43c0d8bb08806c39$export$f221d384e5b0f4c3;

});


//# sourceMappingURL=ForgeContentTools.2c079b11.js.map
